(function() {
    const BROTH_IDS = [48411366424799, 46200479580383, 46200479088863, 46200479121631];
    const BROTH_MAP = { 'beef': 46200479088863, 'chicken': 48411366424799 };
    const TIERS = { FREE: 30000, GIFT: 45000 };
    const CLAIM_LABELS = { 'beef': 'Claim Beef Broth', 'chicken': 'Claim Chicken Broth' };
    const DEBOUNCE_MS = 300;

    let isUpdating = false;
    let lastRun = 0;

    function isCartMutationUrl(url) {
        if (!url || typeof url !== 'string') return false;
        if (url.includes('goal_script=true') || url.includes('bundler-cart-call')) return false;
        return url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/clear');
    }

    function setAllGoalMessages(text) {
        document.querySelectorAll('.cs-cart-goals-container').forEach(el => {
            const msg = el.querySelector('.cs-goal-msg');
            if (msg) msg.textContent = text;
        });
    }

    function setFallbackMessage() {
        setAllGoalMessages('Rewards update paused – refresh the page if needed.');
    }

    // 1. Updater
    async function refreshCarnistoreGoals() {
        if (isUpdating) return;
        if (Date.now() - lastRun < DEBOUNCE_MS) return;
        isUpdating = true;

        try {
            const res = await fetch('/cart.js?v=' + Date.now() + '&goal_script=true');
            const cart = await res.json();

            lastRun = Date.now();
            const total = cart.total_price;
            const brothLineHasDiscount = (cart.items || []).some(function(item) {
                if (!BROTH_IDS.includes(item.variant_id)) return false;
                var orig = item.original_line_price || item.line_price || 0;
                var line = item.line_price || 0;
                return orig > line + 1;
            });

            // Marker 1 (Free Delivery, 300) sits at 50%, Marker 2 (Free Broth, 450) at 95%
            let pct = 0;
            if (total <= TIERS.FREE) pct = (total / TIERS.FREE) * 50;
            else if (total <= TIERS.GIFT) pct = 50 + ((total - TIERS.FREE) / (TIERS.GIFT - TIERS.FREE)) * 45;
            else pct = 100;

            const containers = document.querySelectorAll('.cs-cart-goals-container');
            containers.forEach(el => {
                const fill = el.querySelector('.cs-progress-fill');
                const m1 = el.querySelector('#cs-marker-1');
                const m2 = el.querySelector('#cs-marker-2');
                if (fill) fill.style.width = pct + '%';
                if (m1) m1.classList.toggle('is-completed', total >= TIERS.FREE);
                if (m2) m2.classList.toggle('is-completed', total >= TIERS.GIFT);

                const msg = el.querySelector('.cs-goal-msg');
                const selector = el.querySelector('.cs-gift-selector');

                if (total < TIERS.FREE) {
                    if (msg) msg.innerHTML = `Add <b>${((TIERS.FREE - total)/100).toFixed(2)} AED</b> for FREE Delivery 🚚`;
                    if (selector) selector.style.display = 'none';
                } else if (total < TIERS.GIFT) {
                    if (msg) msg.innerHTML = `Free Delivery Unlocked! 🚚 Add <b>${((TIERS.GIFT - total)/100).toFixed(2)} AED</b> to get a FREE broth 🍲`;
                    if (selector) selector.style.display = 'none';
                } else {
                    if (brothLineHasDiscount) {
                        if (msg) msg.innerHTML = `You’ve unlocked free delivery & a free broth! 🎁`;
                        if (selector) selector.style.display = 'none';
                    } else {
                        if (msg) msg.innerHTML = `🎉 You've unlocked <b>FREE broth</b>, choose your broth below:`;
                        if (selector) selector.style.display = 'block';
                    }
                }
            });
        } catch (e) {
            console.error(e);
            setFallbackMessage();
        }

        setTimeout(() => { isUpdating = false; }, 800);
    }

    // 2. Refresh when drawer opens (theme event)
    document.addEventListener('on:cart-drawer:after-open', function() {
        setTimeout(refreshCarnistoreGoals, 100);
    });

    // 3. Initial run so bar is correct when drawer is already in page
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() { setTimeout(refreshCarnistoreGoals, 400); });
    } else {
        setTimeout(refreshCarnistoreGoals, 400);
    }

    // 4. Interceptors (cart add/change/clear only)
    const originalFetch = window.fetch;
    window.fetch = function() {
        const url = arguments[0];
        const urlString = typeof url === 'string' ? url : (url && url.url || "");

        if (urlString.includes('goal_script=true')) {
            return originalFetch.apply(this, arguments);
        }

        return originalFetch.apply(this, arguments).then(response => {
            if (isCartMutationUrl(urlString)) {
                setTimeout(refreshCarnistoreGoals, 850);
            }
            return response;
        });
    };

    const originalXHR = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function() {
        const url = arguments[1];
        const xhr = this;
        if (!xhr._csGoalsLoadAttached) {
            xhr._csGoalsLoadAttached = true;
            xhr.addEventListener('load', function() {
                if (isCartMutationUrl(url)) {
                    setTimeout(refreshCarnistoreGoals, 850);
                }
            });
        }
        return originalXHR.apply(this, arguments);
    };

    // 5. Refresh when bar is (re)inserted (e.g. theme replaced drawer at 700ms)
    var containerRefreshTimer = 0;
    var containerMo = new MutationObserver(function(mutations) {
        for (var m = 0; m < mutations.length; m++) {
            var nodes = mutations[m].addedNodes;
            for (var n = 0; n < nodes.length; n++) {
                var node = nodes[n];
                if (node.nodeType !== 1) continue;
                if (node.classList && node.classList.contains('cs-cart-goals-container')) {
                    clearTimeout(containerRefreshTimer);
                    containerRefreshTimer = setTimeout(refreshCarnistoreGoals, 150);
                    return;
                }
                if (node.querySelector && node.querySelector('.cs-cart-goals-container')) {
                    clearTimeout(containerRefreshTimer);
                    containerRefreshTimer = setTimeout(refreshCarnistoreGoals, 150);
                    return;
                }
            }
        }
    });
    if (document.body) containerMo.observe(document.body, { childList: true, subtree: true });
    else document.addEventListener('DOMContentLoaded', function() { containerMo.observe(document.body, { childList: true, subtree: true }); });

    // 6. Claim broth
    window.csClaimBroth = function(flavor, evt) {
        const btn = evt && evt.target ? evt.target : null;
        if (!btn || !BROTH_MAP[flavor]) return;
        const originalLabel = CLAIM_LABELS[flavor] || ('Claim ' + flavor + ' Broth');
        btn.innerText = 'Adding...';
        btn.disabled = true;

        fetch('/cart/add.js?goal_script=true', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: BROTH_MAP[flavor], quantity: 1 }] })
        })
        .then(res => res.json().then(data => ({ ok: res.ok, data })))
        .then(({ ok, data }) => {
            if (ok) {
                btn.innerText = 'Added!';
                document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
                setTimeout(function() {
                    refreshCarnistoreGoals();
                    btn.disabled = false;
                    btn.innerText = originalLabel;
                }, 700);
                return;
            }
            btn.innerText = originalLabel;
            btn.disabled = false;
            setAllGoalMessages((data && data.description) ? data.description : "Couldn't add – try again.");
        })
        .catch(() => {
            btn.innerText = originalLabel;
            btn.disabled = false;
            setAllGoalMessages("Couldn't add – try again.");
        });
    };

})();